












































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

import dayjs from 'dayjs';
import 'dayjs/locale/es';

import Button, {
    ButtonSize,
} from '@/modules/shared/components/button.component.vue';
import Input, {
    InputType,
} from '@/modules/shared/components/input.component.vue';
import FieldSet, { IconEnum } from '@/modules/shared/components/field-set.component.vue';
import Modal from '@/modules/shared/components/modal.component.vue';

import UtilsService from '@/modules/core/services/utils.service';
import ValidationService from '@/modules/core/services/validation.service';
import BudgetService from '@/modules/budget/services/budget.service';

import ErrorMixin from '@/modules/shared/mixins/error.mixin.ts';

import { User } from '@/modules/user/model/user.model';

@Component({
    components: {
        Input,
        FieldSet,
        Button,
        Modal,
    },
    computed: {
        ...mapGetters({
            profile: 'getProfile',
        }),
    },
    methods: {
        ...mapActions ({
            destroyStudy: 'destroyStudy',
        }),
    },
})
export default class CloudDocumentView extends Mixins<ErrorMixin> (ErrorMixin) {
    @Prop() private document!: any;
    @Prop({ default: false }) private suggested!: boolean;

    private destroyStudy: any;
    private profile!: User;
    private buttonSize = ButtonSize;
    private iconEnum = IconEnum;
    private isShareModalOpen = false;
    private isDestroyModalOpen = false;
    private email = '';
    public error = {
        email: '',
    };
    private literals = {
        btnDownload: 'DESCARGAR',
        btnShare: 'COMPARTIR',
        btnBudget: 'PRESUPUESTO',
    };

    get formatDate() {
        const formatDate = dayjs(this.document.created, { locale: 'es' }).format('DD MMMM YYYY · HH:mm[h]');
        return formatDate;
    }

    get documentIcon() {
        let icon = '';
        if ( !this.suggested ) {
            icon = this.iconEnum.Cross;
        }
        return icon;
    }

    get hasThumbNail() {
        return this.document.thumbnail && this.document.thumbnail !== null;
    }

    get hasError() {
        let error = false;
        for (const key of Object.keys(this.error)) {
            if ( (this.error as any)[key] !== '' ) {
                error = true;
                break;
            }
        }
        return error;
    }

    get formComplete() {
        return this.email.length > 0;
    }

    private downloadDocument() {
        const url = this.document.file || this.document.pdf;
        UtilsService.openUrl(url);
    }

    private downloadBudget() {
        BudgetService.getStudyBudget(this.document.id)
            .then(
                (res: any) => {
                    const budget = res.data;
                    const document = budget.document;
                    if ( document === null ) {
                        this.createAndDownloadBudget();
                    } else {
                        UtilsService.openUrl(document);
                    }
                },
            );
    }

    private createAndDownloadBudget() {
        BudgetService.createStudyBudget({
            study: this.document.id,
            name: this.document.name,
            phone: (this.profile.profile as any).phone,
            email: this.profile.email,
        })
            .then(
                (res: any) => {
                    const budget = res.data;
                    const document = budget.document;
                    UtilsService.openUrl(document);
                },
            );
    }

    private checkErrors() {
        const emptyFieldMessage = 'Este campo no puede estar vacío';
        if (this.email === '') {
            this.error.email = emptyFieldMessage;
        } else if (! ValidationService.checkValidEmail(this.email)) {
            this.error.email = 'El email introducido no es correcto';
        }
    }

    private shareDocument() {
        this.checkErrors();
        if ( !this.hasError ) {
            this.$store.dispatch('shareDocument', {
                id: this.document.id,
                email: this.email,
            }).then((res) => {
                this.toggleShareModal(false);
            });
        }
    }

    private toggleShareModal(value: boolean) {
        this.isShareModalOpen = value;
    }

    private toggleDestroyModal(value: boolean) {
        this.isDestroyModalOpen = value;
    }

    private destroy() {
        this.destroyStudy({id: this.document.id});
    }

}
